import {useCallback} from 'react'

export default function useEventIdCallback<T, ID>(
  callback: (arg0: T, arg1: ID) => unknown,
  id: ID,
): (arg0: T) => unknown {
  return useCallback(
    (event: T) => {
      callback(event, id)
    },
    [callback, id],
  )
}
